export const ITEM_CARD_WIDTH_INT = 360;
export const ITEM_CARD_WIDTH = "360px";